import { render, staticRenderFns } from "./TransferAcrossBranchesModal.vue?vue&type=template&id=1b45c0e6&scoped=true"
import script from "./TransferAcrossBranchesModal.vue?vue&type=script&lang=js"
export * from "./TransferAcrossBranchesModal.vue?vue&type=script&lang=js"
import style0 from "./TransferAcrossBranchesModal.vue?vue&type=style&index=0&id=1b45c0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b45c0e6",
  null
  
)

export default component.exports